import { Api } from "../api/api";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class DatedSurveyProvider {
  private url: string = "dated_surveys";

  constructor(public api: Api) {}

  post(
    met_user_ids: number[],
    high_evaluation_user_ids: number[]
  ): Observable<any> {
    return this.api.post(this.url, {
      dated_survey: {
        met_user_ids: met_user_ids,
        high_evaluation_user_ids: high_evaluation_user_ids,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/dated-survey/dated-survey.ts